import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import { connect } from 'react-redux';

import SponsorEditorForm from './SponsorEditorForm';

import { createSponsor, editSponsor } from '../../../../../../../actions';

class SponsorEditor extends Component {
  state = {
    fields: {
      newTitle: {
        value: this.props.sponsor.title,
      },
      newImage: {
        value: this.props.sponsor.image,
      },
      newUrl: {
        value: this.props.sponsor.url,
      },
      newActive: {
        value: this.props.sponsor.active,
      },
    },
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.sponsor !== this.props.sponsor) {
      this.setState({
        fields: {
          newTitle: {
            value: nextProps.sponsor.title,
          },
          newImage: {
            value: nextProps.sponsor.image,
          },
          newUrl: {
            value: nextProps.sponsor.url,
          },
          newActive: {
            value: nextProps.sponsor.active,
          },
        },
      });
    }
  }

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  }

  handleOk = () => {
    const { type } = this.props;
    const { newTitle, newImage, newUrl, newActive } = this.state.fields;
    if (type === 'create') {
      Modal.confirm({
        title: 'Xác nhận tạo mới?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          this.props.createSponsor({
            sponsor: {
              title: newTitle.value,
              image: newImage.value,
              url: newUrl.value,
              active: newActive.value,
            },
            response: {
              success: async () => {
                message.success('Tạo mới thành công');
                this.props.closeEditor();
              },
              failure: async (msg = 'Tạo mới không thành công') => {
                message.error(msg);
              },
            },
          });
        },
        onCancel: () => {

        },
      });
    } else if (type === 'edit') {
      const { sponsor: { title, image, url, active } } = this.props;

      const data = {};
      if (newTitle.value !== title && newTitle.value !== '' && newTitle.value) data.title = newTitle.value;
      if (newImage.value !== image && newImage.value !== '' && newImage.value) data.image = newImage.value;
      if (newUrl.value !== url && newUrl.value !== '' && newUrl.value) data.url = newUrl.value;
      if (newActive.value !== active && newActive.value !== '' && newActive.value) data.active = newActive.value;

      Modal.confirm({
        title: 'Bạn chắc chắn sửa?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          const sponsor = { _id: this.props.sponsor._id, ...data };
          this.props.editSponsor({
            sponsor,
            response: {
              success: async () => {
                message.success('Sửa thành công');
                this.props.closeEditor();
              },
              failure: async (msg = 'Sửa không thành công') => {
                message.error(msg);
              },
            },
          });
        },
      });
    }
  }

  handleCancel = () => {
    Modal.confirm({
      title: 'Bạn chắc chắn hủy tác vụ?',
      okText: 'Có',
      okType: 'danger',
      cancelText: 'Không',
      onOk: () => {
        this.props.closeEditor();
      },
    });
  }

  render() {
    const {
      closeEditor,
      showEditor,
      type,
      sponsor: { title, image, url, active },
      formItemLayout,
      tailFormItemLayout,
    } = this.props;
    const { fields: { newImage, newTitle, newUrl, newActive } } = this.state;
    const disabled = newImage.value === '' || newImage.value === undefined ||
                  (newTitle.value === title && newImage.value === image &&
                  newUrl.value === url && newActive.value === active);

    return (
      <Modal
        visible={showEditor}
        title={type === 'create' ? 'Tạo' : 'Sửa'}
        wrapClassName="vertical-center-modal"
        onOk={this.handleOk}
        onCancel={closeEditor}
        footer={[
          <Button key="back" onClick={closeEditor}>Huỷ</Button>,
          <Button key="submit" type="primary" disabled={disabled} onClick={this.handleOk}>
            Đồng ý
          </Button>,
        ]}
      >
        <SponsorEditorForm
          {...this.state.fields}
          onChange={this.handleFormChange}
          formItemLayout={formItemLayout}
          tailFormItemLayout={tailFormItemLayout}
          isCreate={type === 'create'}
        />
      </Modal>
    );
  }
}

export default connect(null, {
  createSponsor,
  editSponsor,
})(SponsorEditor);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/Sponsor/SponsorEditor.js